import {useEffect,useState} from 'react';
import {canonicalSchoolLevel,subjectForSchoolLevel} from './catalog';
import type {AkyoNavigation} from './akyo-taxonomy';

/** UUIDs select live Akyo objects; the emitted key preserves historical storage. */
export function PedagogicalLevelFields({value,onChange,levels,allLabel,navigation:provided}: {
  value:string; onChange:(value:string)=>void; levels?:readonly string[]; allLabel?:string; navigation?:AkyoNavigation;
}) {
  const [navigation,setNavigation]=useState<AkyoNavigation>(provided??[]);
  const [loading,setLoading]=useState(provided===undefined);
  const [loadError,setLoadError]=useState('');
  const [retry,setRetry]=useState(0);
  useEffect(()=>{
    if(provided!==undefined){setNavigation(provided);setLoading(false);setLoadError('');return;}
    const controller=new AbortController();
    setLoading(true);setLoadError('');
    fetch('/api/curriculum',{credentials:'include',signal:controller.signal})
      .then(r=>{
        if(r.status===401)throw Error('Session expirée. Reconnectez-vous pour charger les niveaux et matières.');
        if(r.status===403)throw Error('Accès au référentiel refusé par Competenceo.');
        if(!r.ok)throw Error('Impossible de charger les niveaux et matières.');
        return r.json();
      })
      .then(body=>{if(!controller.signal.aborted){
        setNavigation(body?.navigation??[]);setLoading(false);
        if(body?.source==='legacy')setLoadError('La connexion au référentiel Akyo n’est pas configurée sur le serveur.');
      }})
      .catch(error=>{if(!controller.signal.aborted){setLoading(false);setLoadError(error instanceof SyntaxError||error instanceof TypeError?'Impossible de charger les niveaux et matières.':error.message);}});
    return ()=>controller.abort();
  },[provided,retry]);
  const selected=navigation.find(level=>level.subjects.some(subject=>subject.schoolLevel===value));
  const subject=selected?.subjects.find(subject=>subject.schoolLevel===value);
  const available=navigation.filter(level=>!levels||level===selected||level.subjects.some(s=>levels.includes(s.schoolLevel)));
  const levelValue=value==='all'?'all':selected?.id??'saved';
  return <>
    <label><span>Niveau</span><select aria-label="Niveau" value={levelValue} onChange={event=>{
      if(event.target.value==='all'){onChange('all');return;}
      const next=available.find(level=>level.id===event.target.value);
      const nextSubject=next?.subjects.find(s=>s.code===subject?.code)??next?.subjects[0];
      if(nextSubject)onChange(nextSubject.schoolLevel);
    }}>
      {allLabel&&<option value="all">{allLabel}</option>}
      {!selected&&value!=='all'&&<option value="saved">{canonicalSchoolLevel(value)} — choix enregistré</option>}
      {available.map(level=><option key={level.id} value={level.id}>{level.label}</option>)}
    </select></label>
    {value!=='all'&&<label><span>Matière</span><select aria-label="Matière" value={subject?.id??'saved'} onChange={event=>{
      const next=selected?.subjects.find(s=>s.id===event.target.value);
      if(next)onChange(next.schoolLevel);
    }}>
      {!subject&&<option value="saved">{subjectForSchoolLevel(value)||'Matière non renseignée'} — choix enregistré</option>}
      {selected?.subjects.map(s=><option key={s.id} value={s.id}>{s.label}</option>)}
    </select></label>}
    {(loadError||!navigation.length)&&<div role="status"><small>{loading?'Chargement du référentiel Akyo…':loadError||'Référentiel Akyo indisponible. Choix enregistrés conservés.'}</small>{!loading&&provided===undefined&&<button type="button" onClick={()=>setRetry(n=>n+1)}>Réessayer</button>}</div>}
  </>;
}
